// src/components/products/ProductCard.jsx
import React from "react";
import ProductContainerImage from "./ProductContainerImage";

const ProductCard = ({ item, index, safeText }) => {
  const imageUrl = item.image && item.image[0]?.url;
  const isReversed = index % 2 === 1;
  const isOddProduct = index % 2 === 0;

  const content = (
    <div
      className={`group flex w-full flex-row items-stretch md:h-72 lg:h-80 ${
        isReversed ? "flex-row-reverse" : ""
      } gap-0 overflow-hidden rounded-2xl border shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl ${
        isOddProduct ? "product-card-even" : "product-card-odd"
      }`}
    >
      <div
        className={`product-card-image${
          isReversed ? " product-card-image--reversed" : ""
        }`}
      >
        {imageUrl ? (
          <ProductContainerImage
            src={imageUrl}
            alt={safeText(item.title) || "Product"}
            className="product-card-image__media"
          />
        ) : (
          <div className="product-container-image-placeholder product-card-image__media">
            No Image
          </div>
        )}
      </div>

      <div className="flex min-w-0 flex-1 flex-col justify-between px-3 py-4 sm:px-6 sm:py-6 md:min-h-0 md:overflow-hidden">
        <div className="min-w-0 md:min-h-0 md:overflow-hidden">
          {item.title && (
            <h3 className="product-card-title line-clamp-2 text-xl font-semibold sm:text-2xl md:text-3xl">
              {safeText(item.title)}
            </h3>
          )}
          {item.subtitle && (
            <p className="mt-3 line-clamp-3 text-base leading-loose text-gray-600 sm:line-clamp-4 sm:text-lg md:line-clamp-3">
              {safeText(item.subtitle)}
            </p>
          )}
        </div>

        {item.url && (
          <div className="mt-3 flex shrink-0 items-center justify-end sm:mt-4">
            <span className="inline-flex items-center justify-center w-8 h-8 rounded-full product-btn-icon">
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M14 3h7m0 0v7m0-7L10 14"
                />
              </svg>
            </span>
          </div>
        )}
      </div>
    </div>
  );

  if (!item.url) {
    return <div key={item.id || index}>{content}</div>;
  }

  const lowerUrl = item.url.toLowerCase();
  const isPdf = lowerUrl.endsWith(".pdf");

  let target = "_blank";
  let rel = "noopener noreferrer";

  if (!isPdf && lowerUrl.startsWith("/products/tracetek/")) {
    const segments = lowerUrl.split("/").filter(Boolean);
    if (segments.length <= 3) {
      target = undefined;
      rel = undefined;
    }
  }

  return (
    <a
      key={item.id || index}
      href={item.url}
      target={target}
      rel={rel}
      className="block"
    >
      {content}
    </a>
  );
};

export default ProductCard;
